var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.updateMsg
        ? _c("div", { staticClass: "text-green" }, [
            _vm._v(_vm._s(_vm.updateMsg))
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.loading == true
        ? _c(
            "div",
            { staticClass: "text-center pt-4" },
            _vm._l(10, function(option) {
              return _c("div", { staticClass: "row ml-1" }, [
                _c(
                  "div",
                  {
                    staticClass: "res_heading_1",
                    staticStyle: { "padding-left": "0px" }
                  },
                  [_c("PuSkeleton", { attrs: { count: 1 } })],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "res_heading_2",
                    staticStyle: { "padding-left": "10px" }
                  },
                  [_c("PuSkeleton", { attrs: { count: 1 } })],
                  1
                ),
                _vm._v(" "),
                _vm._m(0, true)
              ])
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.show_more_tasklists === false && _vm.accountTaskListsCount > 0
        ? _c("div", [
            _c(
              "div",
              { staticClass: "col-12 override-padding" },
              [
                _c(
                  "div",
                  {
                    staticClass: "res_offcanvas_header res_heading_1 text-left"
                  },
                  [
                    _vm._v("\n                Task Lists\n                "),
                    _vm.accountTaskListsCount > 3 &&
                    _vm.accountTaskListsCount > 0
                      ? _c(
                          "a",
                          {
                            staticClass: "see-more",
                            attrs: { href: "javascript:void(0)" },
                            on: { click: _vm.showMoreTaskLists }
                          },
                          [_vm._v(" - " + _vm._s(_vm.see_more_tasklists_text))]
                        )
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "res_offcanvas_header res_heading_2 text-center"
                  },
                  [_vm._v("# of Users")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" }),
                _vm._v(" "),
                _vm._l(_vm.lessAccountTaskLists, function(item, uindex) {
                  return _c(
                    "div",
                    { key: uindex, staticClass: "col-12 resources_lists" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "res_offcanvas_content res_heading_1 text-left"
                        },
                        [
                          _c("div", { staticClass: "chkboxwrapper" }, [
                            _c(
                              "div",
                              { staticClass: "custom-control custom-checkbox" },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(item.name) +
                                    "\n                  "
                                )
                              ]
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "res_offcanvas_content res_heading_2 text-center"
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(item.userCount) +
                              "\n                "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "clearfix" })
                    ]
                  )
                })
              ],
              2
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.show_more_tasklists === true && _vm.accountTaskListsCount > 0
        ? _c("div", [
            _c(
              "div",
              { staticClass: "col-12 override-padding" },
              [
                _c(
                  "div",
                  {
                    staticClass: "res_offcanvas_header res_heading_1 text-left"
                  },
                  [
                    _vm._v("\n                Task Lists\n                "),
                    _vm.accountTaskListsCount > 3 &&
                    _vm.accountTaskListsCount > 0
                      ? _c(
                          "a",
                          {
                            staticClass: "see-more",
                            attrs: { href: "javascript:void(0)" },
                            on: { click: _vm.showMoreTaskLists }
                          },
                          [_vm._v(" - " + _vm._s(_vm.see_more_tasklists_text))]
                        )
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "res_offcanvas_header res_heading_2 text-center"
                  },
                  [_vm._v("# of Users")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" }),
                _vm._v(" "),
                _vm._l(_vm.accountTaskLists, function(item, uindex) {
                  return _c(
                    "div",
                    { key: uindex, staticClass: "col-12 resources_lists" },
                    [
                      _vm.readOnly
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "res_offcanvas_content res_heading_1 text-left"
                            },
                            [
                              _c("div", { staticClass: "chkboxwrapper" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "custom-control custom-checkbox"
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(item.name) +
                                        "\n                  "
                                    )
                                  ]
                                )
                              ])
                            ]
                          )
                        : _c(
                            "div",
                            {
                              staticClass:
                                "res_offcanvas_content res_heading_1 text-left"
                            },
                            [
                              _c("div", { staticClass: "chkboxwrapper" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "custom-control custom-checkbox"
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(item.name) +
                                        "\n                  "
                                    )
                                  ]
                                )
                              ])
                            ]
                          ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "res_offcanvas_content res_heading_2 text-center"
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(item.userCount) +
                              "\n                "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "clearfix" })
                    ]
                  )
                })
              ],
              2
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.accountTaskListsCount === 0 && _vm.loading == false
        ? _c("div", [
            _c("div", { staticClass: "font-weight-bold" }, [
              _vm._v("\n            Task Lists\n            "),
              _c(
                "div",
                { staticClass: "row_item_readonly justify-content-md-center" },
                [
                  _c("div", { staticClass: "text-red text-center m-4" }, [
                    _vm._v(
                      _vm._s(
                        _vm.getNoRecordText(
                          _vm.accountTaskListsCount,
                          "Task Lists"
                        )
                      )
                    )
                  ])
                ]
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.show_more_courses === false && _vm.accountCoursesCount > 0
        ? _c("div", [
            _c(
              "div",
              { staticClass: "col-12 override-padding" },
              [
                _c(
                  "div",
                  {
                    staticClass: "res_offcanvas_header res_heading_1 text-left"
                  },
                  [
                    _vm._v("\n                Courses\n                "),
                    _vm.accountCoursesCount > 3 && _vm.accountCoursesCount > 0
                      ? _c(
                          "a",
                          {
                            staticClass: "see-more",
                            attrs: { href: "javascript:void(0)" },
                            on: { click: _vm.showMoreCourses }
                          },
                          [_vm._v(" - " + _vm._s(_vm.see_more_courses_text))]
                        )
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "res_offcanvas_header res_heading_2 text-center"
                  },
                  [_vm._v("# of Users")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" }),
                _vm._v(" "),
                _vm._l(_vm.lessAccountCourses, function(item, coindex) {
                  return _c(
                    "div",
                    { key: coindex, staticClass: "col-12 resources_lists" },
                    [
                      _vm.readOnly
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "res_offcanvas_content res_heading_1 text-left"
                            },
                            [
                              _c("div", { staticClass: "chkboxwrapper" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "custom-control custom-checkbox"
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(item.name) +
                                        "\n                  "
                                    )
                                  ]
                                )
                              ])
                            ]
                          )
                        : _c(
                            "div",
                            {
                              staticClass:
                                "res_offcanvas_content res_heading_1 text-left"
                            },
                            [
                              _c("div", { staticClass: "chkboxwrapper" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "custom-control custom-checkbox"
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(item.name) +
                                        "\n                  "
                                    )
                                  ]
                                )
                              ])
                            ]
                          ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "res_offcanvas_content res_heading_2 text-center"
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(item.userCount) +
                              "\n                "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "clearfix" })
                    ]
                  )
                })
              ],
              2
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.show_more_courses === true && _vm.accountCoursesCount > 0
        ? _c("div", [
            _c(
              "div",
              { staticClass: "col-12 override-padding" },
              [
                _c(
                  "div",
                  {
                    staticClass: "res_offcanvas_header res_heading_1 text-left"
                  },
                  [
                    _vm._v("\n                Courses\n                "),
                    _vm.accountCoursesCount > 3 && _vm.accountCoursesCount > 0
                      ? _c(
                          "a",
                          {
                            staticClass: "see-more",
                            attrs: { href: "javascript:void(0)" },
                            on: { click: _vm.showMoreCourses }
                          },
                          [_vm._v(" - " + _vm._s(_vm.see_more_courses_text))]
                        )
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "res_offcanvas_header res_heading_2 text-center"
                  },
                  [_vm._v("# of Users")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" }),
                _vm._v(" "),
                _vm._l(_vm.accountCourses, function(item, uindex) {
                  return _c(
                    "div",
                    { key: uindex, staticClass: "col-12 resources_lists" },
                    [
                      _vm.readOnly
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "res_offcanvas_content res_heading_1 text-left"
                            },
                            [
                              _c("div", { staticClass: "chkboxwrapper" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "custom-control custom-checkbox"
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(item.name) +
                                        "\n                  "
                                    )
                                  ]
                                )
                              ])
                            ]
                          )
                        : _c(
                            "div",
                            {
                              staticClass:
                                "res_offcanvas_content res_heading_1 text-left"
                            },
                            [
                              _c("div", { staticClass: "chkboxwrapper" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "custom-control custom-checkbox"
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(item.name) +
                                        "\n                  "
                                    )
                                  ]
                                )
                              ])
                            ]
                          ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "res_offcanvas_content res_heading_2 text-center"
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(item.userCount) +
                              "\n                "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "clearfix" })
                    ]
                  )
                })
              ],
              2
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.accountCoursesCount === 0 && _vm.loading == false
        ? _c("div", [
            _c("div", { staticClass: "font-weight-bold" }, [
              _vm._v("\n            Courses\n            "),
              _c(
                "div",
                { staticClass: "row_item_readonly justify-content-md-center" },
                [
                  _c("div", { staticClass: "text-red text-center m-4" }, [
                    _vm._v(
                      _vm._s(
                        _vm.getNoRecordText(_vm.accountCoursesCount, "Courses")
                      )
                    )
                  ])
                ]
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.show_more_assessments === false && _vm.accountAssessmentsCount > 0
        ? _c("div", [
            _c(
              "div",
              { staticClass: "col-12 override-padding" },
              [
                _c(
                  "div",
                  {
                    staticClass: "res_offcanvas_header res_heading_1 text-left"
                  },
                  [
                    _vm._v("\n                Assessments\n                "),
                    _vm.accountAssessmentsCount > 3 &&
                    _vm.accountAssessmentsCount > 0
                      ? _c(
                          "a",
                          {
                            staticClass: "see-more",
                            attrs: { href: "javascript:void(0)" },
                            on: { click: _vm.showMoreAssessments }
                          },
                          [
                            _vm._v(
                              " - " + _vm._s(_vm.see_more_assessments_text)
                            )
                          ]
                        )
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "res_offcanvas_header res_heading_2 text-center"
                  },
                  [_vm._v("# of Users")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" }),
                _vm._v(" "),
                _vm._l(_vm.lessAccountAssessments, function(item, aindex) {
                  return _c(
                    "div",
                    { key: aindex, staticClass: "col-12 resources_lists" },
                    [
                      _vm.readOnly
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "res_offcanvas_content res_heading_1 text-left"
                            },
                            [
                              _c("div", { staticClass: "chkboxwrapper" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "custom-control custom-checkbox"
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(item.name) +
                                        "\n                  "
                                    )
                                  ]
                                )
                              ])
                            ]
                          )
                        : _c(
                            "div",
                            {
                              staticClass:
                                "res_offcanvas_content res_heading_1 text-left"
                            },
                            [
                              _c("div", { staticClass: "chkboxwrapper" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "custom-control custom-checkbox"
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(item.name) +
                                        "\n                  "
                                    )
                                  ]
                                )
                              ])
                            ]
                          ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "res_offcanvas_content res_heading_2 text-center"
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(item.userCount) +
                              "\n                "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "clearfix" })
                    ]
                  )
                })
              ],
              2
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.show_more_assessments === true && _vm.accountAssessmentsCount > 0
        ? _c("div", [
            _c(
              "div",
              { staticClass: "col-12 override-padding" },
              [
                _c(
                  "div",
                  {
                    staticClass: "res_offcanvas_header res_heading_1 text-left"
                  },
                  [
                    _vm._v("\n                Assessments\n                "),
                    _vm.accountAssessmentsCount > 3 &&
                    _vm.accountAssessmentsCount > 0
                      ? _c(
                          "a",
                          {
                            staticClass: "see-more",
                            attrs: { href: "javascript:void(0)" },
                            on: { click: _vm.showMoreAssessments }
                          },
                          [
                            _vm._v(
                              " - " + _vm._s(_vm.see_more_assessments_text)
                            )
                          ]
                        )
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "res_offcanvas_header res_heading_2 text-center"
                  },
                  [_vm._v("# of Users")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" }),
                _vm._v(" "),
                _vm._l(_vm.accountAssessments, function(item, aindex) {
                  return _c(
                    "div",
                    { key: aindex, staticClass: "col-12 resources_lists" },
                    [
                      _vm.readOnly
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "res_offcanvas_content res_heading_1 text-left"
                            },
                            [
                              _c("div", { staticClass: "chkboxwrapper" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "custom-control custom-checkbox"
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(item.name) +
                                        "\n                  "
                                    )
                                  ]
                                )
                              ])
                            ]
                          )
                        : _c(
                            "div",
                            {
                              staticClass:
                                "res_offcanvas_content res_heading_1 text-left"
                            },
                            [
                              _c("div", { staticClass: "chkboxwrapper" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "custom-control custom-checkbox"
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(item.name) +
                                        "\n                  "
                                    )
                                  ]
                                )
                              ])
                            ]
                          ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "res_offcanvas_content res_heading_2 text-center"
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(item.userCount) +
                              "\n                "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "clearfix" })
                    ]
                  )
                })
              ],
              2
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.accountAssessmentsCount === 0 && _vm.loading == false
        ? _c("div", [
            _c("div", { staticClass: "font-weight-bold" }, [
              _vm._v("\n            Assessments\n            "),
              _c(
                "div",
                { staticClass: "row_item_readonly justify-content-md-center" },
                [
                  _c("div", { staticClass: "text-red text-center m-4" }, [
                    _vm._v(
                      _vm._s(
                        _vm.getNoRecordText(
                          _vm.accountAssessmentsCount,
                          "Assessment"
                        )
                      )
                    )
                  ])
                ]
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.show_more_forms === false && _vm.accountFormsCount > 0
        ? _c("div", [
            _c(
              "div",
              { staticClass: "col-12 override-padding" },
              [
                _c(
                  "div",
                  {
                    staticClass: "res_offcanvas_header res_heading_1 text-left"
                  },
                  [
                    _vm._v("\n                Forms\n                "),
                    _vm.accountFormsCount > 3 && _vm.accountFormsCount > 0
                      ? _c(
                          "a",
                          {
                            staticClass: "see-more",
                            attrs: { href: "javascript:void(0)" },
                            on: { click: _vm.showMoreForms }
                          },
                          [_vm._v(" - " + _vm._s(_vm.see_more_forms_text))]
                        )
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "res_offcanvas_header res_heading_2 text-center"
                  },
                  [_vm._v("# of Users")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" }),
                _vm._v(" "),
                _vm._l(_vm.lessAccountForms, function(item, uindex) {
                  return _c(
                    "div",
                    { key: uindex, staticClass: "col-12 resources_lists" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "res_offcanvas_content res_heading_1 text-left"
                        },
                        [
                          _c("div", { staticClass: "chkboxwrapper" }, [
                            _c(
                              "div",
                              { staticClass: "custom-control custom-checkbox" },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(item.name) +
                                    "\n                  "
                                )
                              ]
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "res_offcanvas_content res_heading_2 text-center"
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(item.userCount) +
                              "\n                "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "clearfix" })
                    ]
                  )
                })
              ],
              2
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.show_more_forms === true && _vm.accountFormsCount > 0
        ? _c("div", [
            _c(
              "div",
              { staticClass: "col-12 override-padding" },
              [
                _c(
                  "div",
                  {
                    staticClass: "res_offcanvas_header res_heading_1 text-left"
                  },
                  [
                    _vm._v("\n                Forms\n                "),
                    _vm.accountFormsCount > 3 && _vm.accountFormsCount > 0
                      ? _c(
                          "a",
                          {
                            staticClass: "see-more",
                            attrs: { href: "javascript:void(0)" },
                            on: { click: _vm.showMoreForms }
                          },
                          [_vm._v(" - " + _vm._s(_vm.see_more_forms_text))]
                        )
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "res_offcanvas_header res_heading_2 text-center"
                  },
                  [_vm._v("# of Users")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" }),
                _vm._v(" "),
                _vm._l(_vm.accountForms, function(item, uindex) {
                  return _c(
                    "div",
                    { key: uindex, staticClass: "col-12 resources_lists" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "res_offcanvas_content res_heading_1 text-left"
                        },
                        [
                          _c("div", { staticClass: "chkboxwrapper" }, [
                            _c(
                              "div",
                              { staticClass: "custom-control custom-checkbox" },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(item.name) +
                                    "\n                  "
                                )
                              ]
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "res_offcanvas_content res_heading_2 text-center"
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(item.userCount) +
                              "\n                "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "clearfix" })
                    ]
                  )
                })
              ],
              2
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.accountFormsCount === 0 && _vm.loading == false
        ? _c("div", [
            _c("div", { staticClass: "font-weight-bold" }, [
              _vm._v("\n            Forms\n            "),
              _c(
                "div",
                { staticClass: "row_item_readonly justify-content-md-center" },
                [
                  _c("div", { staticClass: "text-red text-center m-4" }, [
                    _vm._v(
                      _vm._s(_vm.getNoRecordText(_vm.accountFormsCount, "Form"))
                    )
                  ])
                ]
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "ResourcesConfirmModal",
        {
          ref: "confirmation_resources_modal",
          attrs: { isModalVisible: _vm.isResourcesConfirmModalVisible },
          on: {
            close: function($event) {
              _vm.isResourcesConfirmModalVisible = false
            }
          }
        },
        [
          _vm.loading
            ? _c("span", { staticClass: "pull-right text-danger" }, [
                _vm._v("\n        Loading...\n      ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "confirm_message",
              attrs: { slot: "header" },
              slot: "header"
            },
            [
              _vm._v(
                "\n        " + _vm._s(_vm.confirmation_message) + "\n      "
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { attrs: { slot: "body" }, slot: "body" }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "col-12 override-padding",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "button",
                {
                  staticClass: "btn btn-sm cancelBtn float-left",
                  attrs: { type: "button" },
                  on: { click: _vm.closeConfirmationAction }
                },
                [_vm._v(_vm._s(_vm.cancelBtn))]
              ),
              _vm._v(" "),
              _vm.isConfirmBtn
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-sm saveBtn float-right",
                      on: { click: _vm.resourcesConfirmationAction }
                    },
                    [_vm._v("Confirm")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isYesBtn
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-sm saveBtn float-right",
                      on: { click: _vm.doUpdateAssignmentAction }
                    },
                    [_vm._v("Yes")]
                  )
                : _vm._e()
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 p-0" }, [
      _c("div", { staticClass: "custom_hr" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6d1891da", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d1891da","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/enterpriseadmin/resources_tab.vue
// module id = null
// module chunks = 